<template>
  <div class="app-current-auto-top-up">
    <slot name="txtBefore"></slot>
    <dyn-slot :slot-data="slotData">
      <slot v-if="noAutoTopUp" name="txtNoAutoTopUp">
        <div>Du hast zur Zeit keine automatische Aufladung eingerichtet.</div>
      </slot>
      <slot v-if="monthlyAutoTopUp" name="txtMonthlyAutoTopUp">
        <div>Du hast aktuell folgende Aufladeart eingerichtet: <span class="top-up-type">Datumgesteuerte Aufladung</span></div>
        <div>Am 2. eines Monats werden {{ slotData.amount }} auf dein Guthabenkonto geladen. Bitte beachte, dass es bis zu 24 Stunden dauern kann, bis der gewünschte Betrag auf deinem Konto gutgeschrieben wird. Der maximale Aufladebetrag pro Tag beträgt 40 €.</div>
      </slot>
      <slot v-if="thresholdAutoTopUp" name="txtThresholdAutoTopUp">
        <div>Du hast aktuell folgende Aufladeart eingerichtet: <span class="top-up-type">Guthabengesteuerte Aufladung</span></div>
        <div>Wenn dein Guthaben unter {{ slotData.trigger }} fällt, werden automatisch {{ slotData.amount }} auf dein Guthabenkonto aufgeladen.</div>
      </slot>
    </dyn-slot>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'

export default {
  name: 'CurrentAutoTopUp',
  computed: {
    slotData: function () {
      return {
        trigger: this.formattedTrigger,
        amount: this.formattedAmount
      }
    },
    formattedTrigger: function () {
      if (this.topUp === null || this.topUp.trigger === null) {
        return 0
      }
      return this.price(this.topUp.trigger)
    },
    formattedAmount: function () {
      if (this.topUp === null || this.topUp.amount === null) {
        return 0
      }
      return this.price(this.topUp.amount)
    },
    noAutoTopUp: function () {
      return this.topUp === null
    },
    monthlyAutoTopUp: function () {
      return this.topUp !== null && (this.topUp.type === 'DAY_OF_MONTH' || this.topUp.type === 'monthly')
    },
    thresholdAutoTopUp: function () {
      return this.topUp !== null && (this.topUp.type === 'ACCOUNT_BALANCE' || this.topUp.type === 'byLimit')
    }
  },
  mixins: [
    configBasedTopUpPrice
  ],
  props: {
    topUp: {
      type: Object,
      default: null
    }
  }
}
</script>
